export let cancelExecutionAbortController = new AbortController();

/** Error message raised from aborted fetch API call when AbortController's `abort()` is invoked. */
export const DESIGN_AI_ABORT_CONTROLLER_ERROR =
  "Design AI API execution aborted";

/**
 * Used to abort the Design AI API calls involved in task generation
 * and execution when user clicks on 'Cancel' button in Design AI.
 */
export const cancelDesignAITaskAPICalls = () => {
  cancelExecutionAbortController.abort(DESIGN_AI_ABORT_CONTROLLER_ERROR);
  cancelExecutionAbortController = new AbortController();
};
